module.exports = __webpack_public_path__ + "img/riccobene-logo.7dbe32dd.jpg";